/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Availabledates1Inputs */

const en__field_availabledates1 = /** @type {(inputs: _Field_Availabledates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available Days`)
};

const de__field_availabledates1 = /** @type {(inputs: _Field_Availabledates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Tage`)
};

/**
* | output |
* | --- |
* | "Available Days" |
*
* @param {_Field_Availabledates1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_availabledates1 = /** @type {((inputs?: _Field_Availabledates1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Availabledates1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_availabledates1(inputs)
	return de__field_availabledates1(inputs)
});
export { _field_availabledates1 as "_field_availableDates" }